// import React, { useState } from 'react';
// import { Outlet, useLocation } from 'react-router-dom';
// import Sidebar from './Sidebar';
// import './DashboardLayout.css';

// const PAGE_TITLES = {
//   '/dashboard/profile': 'Employee Profile',
//   '/dashboard/punch-in': 'Punch In',
//   '/dashboard/punch-out': 'Punch Out',
//   '/dashboard/jobs': 'Job Details',
//   '/dashboard/attendance': 'Attendance',
//   '/dashboard/leave': 'Leave Management',
//   '/dashboard/query': 'Submit a Query',
//     '/dashboard/Regularization': 'Attendance Regularization', 
//     '/dashboard/report': 'Reports',
// };

// export default function DashboardLayout() {
//   const [collapsed, setCollapsed] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const location = useLocation();
//   const title = PAGE_TITLES[location.pathname] || 'Dashboard';

//   return (
//     <div className={`layout ${collapsed ? 'layout-collapsed' : ''}`}>
//       <Sidebar
//         collapsed={collapsed}
//         onToggle={() => setCollapsed(v => !v)}
//         mobileOpen={mobileOpen}
//         onMobileClose={() => setMobileOpen(false)}
//       />
//       <div className="layout-main">
//         <header className="layout-topbar">
//           <button className="topbar-menu-btn" onClick={() => setMobileOpen(true)}>
//             <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
//               <path d="M3 5h14M3 10h14M3 15h14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
//             </svg>
//           </button>
//           <div className="topbar-title">{title}</div>
//           <div className="topbar-right">
//             <div className="topbar-status">
//               <span className="status-dot" />
//               Active
//             </div>
//           </div>
//         </header>
//         <main className="layout-content">
//           <Outlet />
//         </main>
//       </div>
//     </div>
//   );
// }





import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import './DashboardLayout.css';

const PAGE_TITLES = {
  '/dashboard/profile': 'Employee Profile',
  '/dashboard/punch-in': 'Punch In',
  '/dashboard/punch-out': 'Punch Out',
  '/dashboard/jobs': 'Job Details',
  '/dashboard/attendance': 'Attendance',
  '/dashboard/leave': 'Leave Management',
  '/dashboard/query': 'Submit a Query',
    '/dashboard/Regularization': 'Attendance Regularization', 
    '/dashboard/report': 'Reports',
    '/dashboard/Accounts': 'Accounts',
};

export default function DashboardLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const title = PAGE_TITLES[location.pathname] || 'Dashboard';

  return (
    <div className={`layout ${collapsed ? 'layout-collapsed' : ''}`}>
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed(v => !v)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <div className="layout-main">
        <header className="layout-topbar">
          <button className="topbar-menu-btn" onClick={() => setMobileOpen(true)}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M3 5h14M3 10h14M3 15h14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
          </button>
          <div className="topbar-title">{title}</div>
          <div className="topbar-right">
            <div className="topbar-status">
              <span className="status-dot" />
              Active
            </div>
          </div>
        </header>
        <main className="layout-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
